import styled from '@emotion/styled';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { Content, Footer } from './components';

const Main = styled.main`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: ${({ theme }) => theme.colors.black[100]};
    height: 100vh;
    align-items: center;

    @media (max-width: 768px) {
        background-color: white;
    }

    * {
        font-family: Manrope;
    }
`;

export const LandingPage = memo(() => {
    const queryParams = new URLSearchParams(useLocation().search);
    const object = Object.fromEntries(queryParams);
    const { campaignId, clientKey, UID, embed, ...inputFields } = object;

    return (
        <Main>
            <Content campaignId={campaignId} clientKey={clientKey} UID={UID} inputFields={inputFields} embed={embed != null} />
            {embed == null && <Footer />}
        </Main>
    );
});
